import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './playerChoiceCount.css'

export default class PlayerChoiceCount extends Component {


  render() {
    var counterClass = this.props.selectedAnswer === this.props.label ? 
      'player-choice-count player-choice-count--selected' : 'player-choice-count';

      if (this.props.answered === true) {
        if (this.props.correctAnswer === this.props.label) {
          counterClass = `${counterClass} player-choice-count--win`
        } else {
          counterClass = `${counterClass} player-choice-count--loss`
        }
      }

    return (
      <div className={counterClass}>
        <div className='player-choice-count__counter'>{this.props.count}</div>
        <p className={`player-choice-count__label player-choice-count__label--${this.props.label}`}>{this.props.label}</p>
      </div>
    );
  }
}

PlayerChoiceCount.propTypes = {
  label: PropTypes.string,
  count: PropTypes.number, 
  selectedAnswer: PropTypes.string, 
  correctAnswer: PropTypes.string, 
  answered: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/components/player-choice-count/playerChoiceCount.js